import { TimerDto, TournamentResponse } from "../api/tournament";
import { PointPaidDto } from "../pages/solution/components/point-paid";
import { calculateHomeLevel } from "../pages/timer-controller/hooks/timer";
import {
  MoneyInChip,
  StructuresResponse,
  TournamentType,
} from "../pages/tournament/hook/useEditTournament";

export function prize(
  data: TournamentResponse,
  item: MoneyInChip,
  index: number,
) {
  if (item.isSubPrize) {
    return "";
  }

  if (data.tournamentType === TournamentType.Tournament) {
    const prize = (
      item.point +
      (data.isAdditional && JSON.parse(data.additionalList).length > 0
        ? JSON.parse(data.additionalList)[index].prize
          ? JSON.parse(data.additionalList)[index].prize
          : 0
        : 0)
    ).toLocaleString();
    return prize;
  } else {
    const prize = getDailyPrize(data, item, data.isDiscountExcluded);
    const moneyInChip = data.moneyInChip;
    const decimalPrizeList: number[] = moneyInChip.map((chip) => {
      return getDecimalAsNumber(
        getDailyPrize(data, chip, data.isDiscountExcluded),
      );
    });

    const maxIndex = decimalPrizeList.reduce(
      (maxIdx, currVal, currIdx, arr) =>
        currVal > arr[maxIdx] ? currIdx : maxIdx,
      0,
    );

    const resultPrize =
      maxIndex === index ? Math.ceil(prize) : Math.floor(prize);

    return resultPrize.toLocaleString();
  }
}
export function prizeType(item: MoneyInChip) {
  if (item.isSubPrize) {
    return "";
  }
  return "RABBIT";
}

export function prizeSubFix(
  data: TournamentResponse,
  item: MoneyInChip,
  index: number,
  isDiscountExcluded?: boolean,
) {
  const prize = getDailyPrize(data, item, isDiscountExcluded);

  const moneyInChip = data.moneyInChip;
  const decimalPrizeList: number[] = moneyInChip.map((chip) => {
    return getDecimalAsNumber(getDailyPrize(data, chip, isDiscountExcluded));
  });

  const maxIndex = decimalPrizeList.reduce(
    (maxIdx, currVal, currIdx, arr) =>
      currVal > arr[maxIdx] ? currIdx : maxIdx,
    0,
  );

  const resultPrize = maxIndex === index ? Math.ceil(prize) : Math.floor(prize);

  return `${resultPrize.toLocaleString()} RABBIT`;
}

export function getDailyPrize(
  data: TournamentResponse,
  item: MoneyInChip,
  isDiscountExcluded?: boolean,
) {
  const total = dailyAllPrize(data, isDiscountExcluded);

  const prizeRate = 10000;
  return ((total / prizeRate) * item.point) / 100;
}

export function getDecimalAsNumber(num: number) {
  const decimal = num % 1;
  return parseFloat(decimal.toFixed(10));
}

export function dailyAllPrize(
  data: TournamentResponse,
  isDiscountExcluded?: boolean,
) {
  let total =
    data.entryUserCount * (data.buyIn || 0) +
    data.adOnUserCount * (data.addOn || 0) +
    data.reBuyInUserCount * (data.reBuyIn || 0);

  if (isDiscountExcluded) {
    total -= data.totalDiscount;
  }
  return total;
}

export function rewardPrize(
  total: number,
  item: PointPaidDto,
  tournament: TournamentResponse,
) {
  const prizeRate = 10000;
  const itemPrize = item.seedPrize || 0;
  let totalPrize = total;
  if (tournament.isDiscountExcluded) {
    totalPrize -= tournament.totalDiscount;
  }
  return item.payMent
    ? itemPrize
    : `${Math.floor(((totalPrize / prizeRate) * itemPrize) / 100)}`;
}

export function rewardDailyPrize(
  total: number,
  prize: number,
  index: number,
  tournament?: TournamentResponse,
) {
  if (!tournament) return 0;
  let totalPrize = total;
  if (tournament.isDiscountExcluded) {
    totalPrize -= tournament.totalDiscount;
  }
  const prizeRate = 10000;
  const newPrize = ((totalPrize / prizeRate) * prize) / 100;

  const moneyInChip = tournament.moneyInChip;
  const prizeList: number[] = moneyInChip.map((chip) => {
    return getDecimalAsNumber(
      getDailyPrize(tournament, chip, tournament.isDiscountExcluded),
    );
  });

  const maxIndex = prizeList.reduce(
    (maxIdx, currVal, currIdx, arr) =>
      currVal > arr[maxIdx] ? currIdx : maxIdx,
    0,
  );

  const resultPrize =
    maxIndex === index ? Math.ceil(newPrize) : Math.floor(newPrize);
  return resultPrize;
}

export function calculatePercentage(remainingTime: number, totalTime: number) {
  const percentage = ((totalTime - remainingTime) / totalTime) * 100;
  return percentage;
}

export function formatNumber(num: number) {
  if (!num) return "0";
  if (num >= 100000000) {
    const converted = (num / 100000000).toFixed(2);
    return `${converted}억`;
  } else {
    return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
}

export function convertToKoreanNumber(num?: number) {
  if (!num) {
    return 0;
  }
  if (num < 10000) {
    return num.toLocaleString();
  }

  const manUnit = Math.floor(num / 10000);
  const remainder = num % 10000;

  const decimalPart = (remainder / 10000).toFixed(1).slice(1);

  return decimalPart === ".0" ? `${manUnit}만` : `${manUnit}${decimalPart}만`;
}

export const getLevel = (timerDto: TimerDto, levels: StructuresResponse[]) => {
  const now = new Date();
  const updatedAt = new Date(timerDto.updatedAt);
  let elapsedTimeMs = 0;
  if (timerDto.isStop) {
    elapsedTimeMs = timerDto.playTime;
  } else {
    elapsedTimeMs = now.getTime() - updatedAt.getTime() + timerDto.playTime;
  }

  const { currentLevel } = calculateHomeLevel(elapsedTimeMs, levels);

  return currentLevel;
};

export function isRegistrationAvailable(item: TournamentResponse) {
  return item.timerDto && item.structure && !item.isEnd
    ? getLevel(item.timerDto, item.structure)?.level
      ? (getLevel(item.timerDto, item.structure)?.level || 1) <=
        item.registerDeadlineLevel
        ? true
        : false
      : false
    : !item.timerDto && !item.isEnd
      ? true
      : false;
}

export function getResultTime(item: TournamentResponse) {
  if (!item.timerDto) return 0;
  let now = new Date();

  const updatedAt = new Date(item.timerDto.updatedAt);

  let elapsedTimeMs;

  if (item.timerDto.isStop) {
    elapsedTimeMs = item.timerDto.playTime;
  } else {
    elapsedTimeMs =
      now.getTime() - updatedAt.getTime() + item.timerDto.playTime;
  }

  return elapsedTimeMs;
}
